// State management for provider view-as functionality

export const setProviderViewAsSession = async (providerGuid: string) => {
    localStorage.setItem('internal-provider-guid', providerGuid);
}

export const clearProviderViewAsSession = () => {
    localStorage.removeItem('internal-provider-guid');
}

export const getProviderViewAsSessionGuid = () => {
    return localStorage.getItem('internal-provider-guid');
}


